export enum TypAkce {
	VYTVORENI = 'VYTVORENI',
	CTENI = 'CTENI',
	AKTUALIZACE = 'AKTUALIZACE',
	MAZANI = 'MAZANI',
	OSTATNI = 'OSTATNI'
}
